// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";
import { useGetPolicyUrls } from "../../../hooks/useGetPolicyUrls";

// COMPONENTI
import SubHeaderDefault from "../../Header/subHeader/SubHeaderDefault";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import NotFound from "../../Error/NotFound";

// STILI
import '../../../assets/styles/PolicyStyles.css';

interface CookieProps {
    agencyId: number;
    policy: number;
    isPrivacy: boolean;
}

const Cookies: React.FC<CookieProps> = ({ agencyId, policy, isPrivacy }) => {
    const { t } = useTranslation()

    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);
    const { policyHTML, loading: policyLoading, error: policyError } = useGetPolicyUrls(policy, isPrivacy);
    console.log(policyHTML);

    // --- Gestione Loading / Errore ---
    if (agencyLoading || policyLoading) {
        return <LoadingIndicator />;
    }

    // Gestione errori caricamento dati
    if (agencyError || policyError) {
        console.error("Errore caricamento dati Cookies page:", agencyError || policyError);
        return <NotFound message={t('validation.policyLoadError') ?? "Errore durante il caricamento del contenuto della policy."} />;
    }

    // Gestione agenzia non trovata (dopo caricamento)
    if (!agency) {
        return <NotFound message={t('common.agencyNotFound') ?? "Agenzia non trovata"} />;
    }

    // --- Preparazione Testi Tradotti ---
    const agencyName = agency?.agencyName ?? t('common.defaultAgencyName');
    const pageTitle = t('cookiePolicy.title');
    const helmetTitle = t('common.pageTitlePattern', { pageTitle: pageTitle, agencyName: agencyName });

    return (
        <>
            <Helmet>
                <title>{helmetTitle ?? pageTitle}</title>
            </Helmet>

            <SubHeaderDefault title={pageTitle ?? 'Cookie Policy'} isSeo={true} />

            <section className="container py-4">

                {policyHTML ? (
                    <div className="policy-content-wrapper" dangerouslySetInnerHTML={{ __html: policyHTML }} />
                ) : (
                    <p>{t('validation.policyLoadError')}</p>
                )}

            </section>
        </>
    );
};

export default Cookies;